export function planningDestination(loggedIn, user = {}) {
    if (!loggedIn) return "/login";
    return user?.admin === true ? null : "/";
}
